module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAJJJREFUWAntljEKgDAQBBOx8V0WfiTPykd8mWCjXHcHVjLNwqa6NMsyk8D1fd5PUzgKRaPjogAzOroobWr9Cjzm9euDnWPrOY/KiUyrz2SJ2UQJijnDRDMNYjZRgmLOkCHavD1lb8Aso95LCWC7RMiod9HiDbiYKACxRJhowQFcZIh6KQFslwgZ9TJFu8LiHG/gBfnwJv/nh6fFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/mixers/QuickSelection-01.png
// module id = 252
// module chunks = 2